// extracted by mini-css-extract-plugin
export default {"playPauseIcon":"PlayPauseIcon--playPauseIcon--zz35n","fade":"PlayPauseIcon--fade--QWkyK"};